import { useCallback, useState } from 'react';

export function useInputState(
    initialState = ''
): [string, (e: React.ChangeEvent<{ value: string }>) => void, (value?: string) => void] {
    const [state, setState] = useState(initialState);
    const onInputChange = useCallback(
        (e: React.ChangeEvent<{ value: string }>) => setState(e.target.value),
        []
    );
    const onValueChange = useCallback((value?: string) => setState(value ?? ''), []);

    return [state, onInputChange, onValueChange];
}
